import React from 'react';
import { Modal } from 'antd';

const preBlockStyle = {
  whiteSpace: 'pre-wrap',
  fontSize: 12,
  background: '#f5f5f5',
  padding: 8,
  borderRadius: 4,
  maxHeight: 320,
  overflowY: 'auto',
};

function formatFailItem(item) {
  if (item == null) return '';
  if (typeof item === 'string') return item;
  if (typeof item === 'object') {
    const row = item.row ?? item.line ?? item.index ?? item.Row;
    const reason = item.reason ?? item.message ?? item.error ?? item.msg ?? '';
    const meter =
      item.meter_no ??
      item.current_meter_no ??
      item.表号 ??
      item.MeterNo;
    const parts = [
      row != null && row !== '' ? `第${row}行` : null,
      meter ? `表号/标识：${meter}` : null,
      reason || null,
    ].filter(Boolean);
    return parts.length ? parts.join('，') : JSON.stringify(item);
  }
  return String(item);
}

function ErrorDetails({ errorPreview, failDetails }) {
  const list = Array.isArray(failDetails) ? failDetails : null;
  if (list && list.length > 0) {
    return (
      <div style={{ marginTop: 12 }}>
        <strong>失败明细：</strong>
        <ul style={{ paddingLeft: 18, marginBottom: 0, marginTop: 8 }}>
          {list.map((item, i) => (
            <li key={i} style={{ fontSize: 12, marginBottom: 4 }}>
              {formatFailItem(item)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  if (errorPreview) {
    return (
      <div style={{ marginTop: 12 }}>
        <strong>错误详情：</strong>
        <pre style={preBlockStyle}>{errorPreview}</pre>
      </div>
    );
  }
  return null;
}

/** 从 axios 错误中抽取可读文案（兼容 msg / message / error） */
export function getBatchImportHttpErrorMessage(error) {
  const d = error?.response?.data;
  if (d == null) return error?.message || '请求失败，请重试';
  if (typeof d === 'string') return d;
  return d.msg || d.message || d.error || '导入失败，请重试';
}

/** HTTP 失败时用弹窗展示（含 error_preview） */
export function showBatchImportHttpError(error) {
  const data = error?.response?.data;
  const text = getBatchImportHttpErrorMessage(error);
  Modal.error({
    title: '导入失败',
    width: 600,
    content: (
      <div>
        <p>{text}</p>
        {data?.error_preview && (
          <div style={{ marginTop: 12 }}>
            <strong>错误详情：</strong>
            <pre style={preBlockStyle}>{data.error_preview}</pre>
          </div>
        )}
      </div>
    ),
  });
}

/**
 * 批量导入结果弹窗（设备、汇付等共用）
 * 约定后端字段：success、msg、success_count、fail_count、error_preview、fail_details（可选数组）
 */
export function showBatchImportResult(res, { entityName = '记录' } = {}) {
  if (!res) {
    Modal.error({ title: '导入失败', content: '未收到服务器响应' });
    return;
  }

  const failDetails = res.fail_details ?? res.failDetails;

  if (!res.success) {
    Modal.error({
      title: '导入失败',
      width: 640,
      content: (
        <div>
          <p>
            {res.msg ||
              res.error ||
              '操作未成功。常见原因：表号/设备已存在、数据格式错误、必填项缺失等，请对照模板检查。'}
          </p>
          <ErrorDetails errorPreview={res.error_preview} failDetails={failDetails} />
        </div>
      ),
    });
    return;
  }

  const failCount = res.fail_count ?? res.failCount ?? 0;
  const successCount = res.success_count ?? res.successCount;
  const msg = res.msg || '';

  if (failCount > 0) {
    Modal.warning({
      title: '导入完成（部分失败）',
      width: 640,
      content: (
        <div>
          <p>
            {msg ||
              `已成功 ${successCount != null ? successCount : '-'} 条，失败 ${failCount} 条。失败原因见下方。`}
          </p>
          <ErrorDetails errorPreview={res.error_preview} failDetails={failDetails} />
        </div>
      ),
    });
    return;
  }

  Modal.success({
    title: '导入成功',
    width: 520,
    content: (
      <div>
        {successCount != null && (
          <p>
            已成功导入 <strong>{successCount}</strong> 条{entityName}。
          </p>
        )}
        {successCount == null && msg && <p>{msg}</p>}
        {successCount == null && !msg && <p>批量导入已完成。</p>}
        {successCount != null && msg && (
          <p style={{ marginTop: 8, color: '#666', fontSize: 13 }}>{msg}</p>
        )}
      </div>
    ),
  });
}
